import { FormatNumber, Tag, Text } from "@chakra-ui/react";

function HealthIssueCell ({ fragments, unhealthy_fragments }: { fragments: number, unhealthy_fragments: number }) {
  const percentage = fragments ? unhealthy_fragments / fragments : 0;
  const color = percentage > 0.5 ? "red" : percentage > 0.2 ? "yellow" : "green";

  return (
    <>
      <Tag.Root size="md" fontWeight={600} colorPalette={color}>
        <Tag.Label>
          <Text display="inline" pr="1">{unhealthy_fragments}</Text>
          {fragments > 0 && <Percentage value={percentage} />}
        </Tag.Label>
      </Tag.Root>
    </>
  );
}

const Percentage = ({ value }: { value: number }) => {
  if (!value) return;

  return (
    <>
      <Text display="inline">(</Text>
      <FormatNumber
        value={value}
        // eslint-disable-next-line react/style-prop-object
        style="percent"
        maximumFractionDigits={2}
      />
      <Text display="inline">)</Text>
    </>
  );
};

export default HealthIssueCell;
